export const TEAM_INFO = {
    // Public display order: city A→Z ("Vegas" treated as "Las Vegas").
    bos: { name: "Boston Fleet", abbr: "BOS", color: "#163F35" },
    det: { name: "Detroit", abbr: "DET", color: "#D60028" },
    ham: { name: "Hamilton", abbr: "HAM", color: "#FFB81C" },
    lvs: { name: "Vegas", abbr: "LV",  color: "#A5A290" },
    min: { name: "Minnesota Frost", abbr: "MIN", color: "#9E7DC5" },
    mtl: { name: "Montreal Victoire", abbr: "MTL", color: "#852734" },
    nyc: { name: "New York Sirens", abbr: "NY", color: "#00B9B3" },
    ott: { name: "Ottawa Charge", abbr: "OTT", color: "#A51B2F" },
    sj:  { name: "San Jose", abbr: "SJ",  color: "#F2671F" },
    sea: { name: "Seattle Torrent", abbr: "SEA", color: "#0A5258" },
    tor: { name: "Toronto Sceptres", abbr: "TOR", color: "#307fe2" },
    van: { name: "Vancouver Goldeneyes", abbr: "VAN", color: "#0F4777" },
};

// Public-facing PWHL team display order: city A→Z, treating "Vegas" as "Las Vegas".
export const PWHL_TEAM_ORDER = ["boston", "detroit", "hamilton", "vegas", "minnesota", "montreal", "new york", "ottawa", "san jose", "seattle", "toronto", "vancouver"];
export const teamOrderIndex = (name) => {
    const n = String(name || "").toLowerCase();
    const i = PWHL_TEAM_ORDER.findIndex((k) => n.includes(k));
    return i === -1 ? 999 : i;
};
export const orderTeams = (arr) => [...(arr || [])].sort((a, b) => teamOrderIndex(a.name) - teamOrderIndex(b.name) || (a.name || "").localeCompare(b.name || ""));

// 2-wave PWHL expansion (mirrors backend / admin shared). Teams only appear in
// a season on/after their first season.
export const TEAM_FIRST_SEASON = {
    sea: "2025-26", van: "2025-26",
    det: "2026-27", ham: "2026-27", sj: "2026-27", lvs: "2026-27",
};
export const teamEligibleForSeason = (id, season) => {
    const first = TEAM_FIRST_SEASON[id];
    if (!first || !season) return true;
    return String(season) >= first;
};
export const orderedTeamIdsForSeason = (season) =>
    orderTeams(Object.keys(TEAM_INFO).map((id) => ({ id, name: TEAM_INFO[id].name })))
        .map((t) => t.id)
        .filter((id) => teamEligibleForSeason(id, season));
// All 12 teams (season-agnostic) — used by the team strip everywhere except Schedule.
export const allTeamIds = () =>
    orderTeams(Object.keys(TEAM_INFO).map((id) => ({ id, name: TEAM_INFO[id].name }))).map((t) => t.id);

export const teamAbbr = (id) => TEAM_INFO[id]?.abbr ?? "—";export const teamName = (id) => TEAM_INFO[id]?.name ?? "Unknown";
// Live team colours (owner-editable primary_color from the DB) override the
// static fallbacks so every story card matches the team's REAL primary colour.
let LIVE_TEAM_COLORS = {};
export const setLiveTeamColors = (map) => { LIVE_TEAM_COLORS = map || {}; };
// Detroit's live/primary colour resolves to a dark navy that renders as
// unreadable near-black on the dark story cards, so force their SECONDARY red
// (a controlled crimson in the Ottawa/Montreal family — not bright) everywhere.
const TEAM_COLOR_OVERRIDE = { det: "#BC1F35" };
export const teamColor = (id) => TEAM_COLOR_OVERRIDE[id] || LIVE_TEAM_COLORS[id] || TEAM_INFO[id]?.color || "#9D4CDD";

// Multi-colour brand palettes for Social Studio (primary / secondary / accent / light / dark).
// Used to colour template elements per-team (header = primary, box = secondary, etc.).
export const TEAM_PALETTES = {
    bos: { primary: "#173F35", secondary: "#C8A95B", accent: "#1E5C4A", light: "#F4F1E9", dark: "#0B231D" },
    det: { primary: "#D60028", secondary: "#0B1F3A", accent: "#F2C14E", light: "#F5F5F5", dark: "#0B0B0B" },
    ham: { primary: "#FFB81C", secondary: "#1A1A1A", accent: "#E0392B", light: "#FFFFFF", dark: "#111111" },
    lvs: { primary: "#A5A290", secondary: "#1A1A1A", accent: "#C8A95B", light: "#F2F1EC", dark: "#0E0E0E" },
    min: { primary: "#2A2D63", secondary: "#9E7DC5", accent: "#7FD3E6", light: "#F0F1FB", dark: "#14152F" },
    mtl: { primary: "#862633", secondary: "#0B1F3A", accent: "#C8A95B", light: "#F4ECEC", dark: "#3D0F16" },
    nyc: { primary: "#00B9B3", secondary: "#E03A3E", accent: "#0B2C5A", light: "#EAF8F7", dark: "#063F3C" },
    ott: { primary: "#A51B2F", secondary: "#1A1A1A", accent: "#C8A95B", light: "#F5ECEC", dark: "#3A0A12" },
    sj: { primary: "#F2671F", secondary: "#0E7C7B", accent: "#1A1A1A", light: "#FFF3EC", dark: "#5C2408" },
    sea: { primary: "#0A5258", secondary: "#5FB6C9", accent: "#E9D6A8", light: "#E9F4F4", dark: "#063033" },
    tor: { primary: "#307fe2", secondary: "#FDD006", accent: "#1A1A1A", light: "#FFFCEC", dark: "#0B2147" },
    van: { primary: "#0F4777", secondary: "#C8A95B", accent: "#2D8FD0", light: "#EAF1F8", dark: "#082A48" },
};
export const teamPalette = (id) => TEAM_PALETTES[id] || { primary: TEAM_INFO[id]?.color || "#9D4CDD", secondary: "#0A0B10", accent: "#F5C518", light: "#F4F1E9", dark: "#0A0B10" };
